const EMPTY_ARRAY = Object.freeze([]);
const EMPTY_FACE_MATCH_HISTORY = Object.freeze({ truck: EMPTY_ARRAY, car: EMPTY_ARRAY });
const EMPTY_SELECTED_IMAGES = Object.freeze({ face: null, id: null });
const EMPTY_SELECTED_IMAGES_BY_TRANSACTION = Object.freeze({
    truck: EMPTY_SELECTED_IMAGES,
    car: EMPTY_SELECTED_IMAGES,
});
const EMPTY_OBJECT = Object.freeze({});

export const selectFaceMatchState = (state) => state.faceMatch;
export const selectFaceMatchIsLoading = (state) => state.faceMatch?.isLoading ?? false;
export const selectFaceMatchError = (state) => state.faceMatch?.error;
export const selectFaceMatchResponse = (state) => state.faceMatch?.response;
export const selectFaceMatchSimilarity = (state) => state.faceMatch?.similarity;
export const selectFaceMatchIsMatch = (state) => state.faceMatch?.isMatch ?? false;
export const selectCurrentMatchType = (state) => state.faceMatch?.currentMatchType;
export const selectFaceMatchIsLoadingForTransaction = (transactionId) => (state) =>
    state.faceMatch?.isLoading && state.faceMatch?.transactionId === transactionId;
export const selectCurrentMatchTypeForTransaction = (transactionId) => (state) =>
    state.faceMatch?.transactionId === transactionId ? state.faceMatch?.currentMatchType : null;
export const selectFaceMatchHistory = (state) => state.faceMatch?.history ?? EMPTY_OBJECT;
export const selectFaceMatchHistoryByTransaction = (transactionId) => (state) =>
    state.faceMatch?.history?.[transactionId] ?? EMPTY_FACE_MATCH_HISTORY;
export const selectTruckFaceMatchHistory = (transactionId) => (state) => state.faceMatch?.history?.[transactionId]?.truck ?? EMPTY_ARRAY;
export const selectCarFaceMatchHistory = (transactionId) => (state) => state.faceMatch?.history?.[transactionId]?.car ?? EMPTY_ARRAY;
export const selectLatestTruckMatch = (transactionId) => (state) => {
    const history = state.faceMatch?.history?.[transactionId]?.truck;
    return history && history.length > 0 ? history[0] : null;
};

export const selectFaceMatchLatestAttempt = (transactionId) => (state) => state.faceMatch?.latestAttemptByTransactionId?.[transactionId] ?? null;

export const selectLatestCarMatch = (transactionId) => (state) => {
    const history = state.faceMatch?.history?.[transactionId]?.car;
    return history && history.length > 0 ? history[0] : null;
};

export const selectSelectedImages = (state) => state.faceMatch?.selectedImages ?? EMPTY_OBJECT;

export const selectSelectedImagesByTransaction = (transactionId) => (state) =>
    state.faceMatch?.selectedImages?.[transactionId] ?? EMPTY_SELECTED_IMAGES_BY_TRANSACTION;

export const selectSelectedTruckImages = (transactionId) => (state) =>
    state.faceMatch?.selectedImages?.[transactionId]?.truck ?? EMPTY_SELECTED_IMAGES;

export const selectSelectedCarImages = (transactionId) => (state) => state.faceMatch?.selectedImages?.[transactionId]?.car ?? EMPTY_SELECTED_IMAGES;
